{
  "title": "Мониторы",
  "add": "Добавить монитор",
  "create": "Создать монитор",
  "edit": "Изменить",
  "enable": "Включить",
  "disable": "Выключить",
  "off": "выключен",
  "emptyTitle": "Мониторов нет",
  "emptyHint": "Без монитора узел останется серым: платформа не проверяет его и не знает, доступен ли он. Самая простая проверка — ICMP по адресу узла.",
  "deleteConfirm": "Удалить монитор? История проверок сохранится.",
  "kindLabel": "Тип проверки",
  "kindFixed": "Тип не меняется: удалите монитор и создайте новый",
  "target": "Цель",
  "targetPlaceholder": "адрес узла",
  "targetHint": "пусто — берётся адрес узла",
  "targetRequired": "у узла нет адреса, поэтому цель обязательна",
  "interval": "Интервал, с",
  "intervalHint": "не менее {{min}}",
  "timeout": "Ожидание, мс",
  "failThreshold": "Порог падения",
  "failThresholdHint": "неудач подряд",
  "okThreshold": "Порог подъёма",
  "okThresholdHint": "успехов подряд",
  "timeoutTooBig": "Ожидание не должно превышать интервал: иначе проверки наезжают друг на друга.",
  "everySeconds": "каждые {{seconds}} с",
  "timeoutMs": "ожидание {{ms}} мс",
  "thresholds": "порог {{fail}}/{{ok}}",
  "inStateSince": "в этом состоянии с {{at}}",
  "checkRequested": "Проверка запрошена — результат придёт через несколько секунд.",
  "checkNowHint": "Результат придёт телеметрией через несколько секунд",
  "checkNowDisabled": "Выключенный монитор не проверяется",
  "noChecksYet": "проверок ещё не было",
  "offNoChecks": "выключен, проверок нет",
  "checkedAgo": "проверен {{ago}} · {{at}}",
  "overdue": "дольше обычного",
  "rtt": "{{value}} мс",
  "http": {
    "path": "Путь",
    "expectStatus": "Ожидаемые коды",
    "commaSeparated": "через запятую",
    "followRedirects": "Идти по редиректам",
    "expectBody": "Подстрока в теле",
    "expectBodyHint": "пусто — тело не проверяется"
  },
  "snmp": {
    "oidHint": "цифры через точку",
    "version": "Версия",
    "expectValue": "Ожидаемое значение",
    "expectValueHint": "пусто — достаточно самого ответа"
  },
  "chart": {
    "label": "Отклик за час{{peak}}, {{view}}",
    "peakSuffix": ", пик {{value}} мс",
    "hour": "час",
    "hourPeak": "час · пик {{value}} мс",
    "bars": "Столбики",
    "line": "Линия",
    "noRecentData": "за последний час проверок не было"
  }
}
